import React, { useEffect, useState } from 'react';
import useStore from '../../store';
import MiniGameRouter from './MiniGameRouter'; // Используем роутер из arcade
import './ArcadeBoard.css'; // Создай простой CSS для фона

const ArcadeBoard = () => {
  const store = useStore.getState();
  const { info } = store.ref;
  const game = info.game;

  const [timeLeft, setTimeLeft] = useState(0);

  // Таймер обратного отсчета
  useEffect(() => {
    const endTime = game.arcadeData.endTime;
    const interval = setInterval(() => {
      const serverTime = store.ref.info.methods.serverTimeFun();
      const delta = Math.ceil((endTime - serverTime) / 1000);
      setTimeLeft(delta > 0 ? delta : 0);
    }, 1000);
    return () => clearInterval(interval);
  }, [game.arcadeData.endTime]);

  return (
    <div className="arcade-board-container">

      <MiniGameRouter
        gameType={game.arcadeData.type}
        onClose={() => window.Telegram?.WebApp?.close()}
        timeLeft={timeLeft}
        // Передаем socket явно, он берется из store в MiniGameRouter, но лучше убедиться
      />
    </div>
  );
};

export default ArcadeBoard;